<template>
  <div class="page">
    <h4 class="text-h4 mb-3">
      {{ $t("tokens.title", { count: 10 }) }}
    </h4>
    <p class="mb-3">
      {{ $t("tokens.description") }} {{ balance }}
    </p>
    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      :footer-props="footerProps"
    >
      <template v-slot:item.dateCreated="{ item }">
        {{ item.dateCreated | formatDate }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getTokenBalance, getTokenLog } from "@/api/craiyon";
import { mapState } from "vuex";

export default {
  data() {
    return {
      balance: 0,
      items: [],
      loading: false
    };
  },
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token
    }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("tokens.table.footerText")
      }
    },
    headers() {
      return [
        {
          text: this.$t("tokens.table.created"),
          value: "datecreated"
        },
        {
          text: this.$t("tokens.table.action"),
          value: "action"
        },
        {
          text: this.$t("tokens.table.amount"),
          value: "balance"
        }
      ]
    },
    acceptedStatus() {
      return this.$t("tokens.status.accepted")
    },
    rejectedStatus() {
      return this.$t("tokens.status.rejected")
    }
  },
  methods: {
    memo(item) {
      if (item.memo_type !== "text") return {};
      const s = item.memo.split("#");
      const status = s[0] === "a" ? this.acceptedStatus : this.rejectedStatus;
      return { status, annotationId: s[1], amount: s[2] };
    }
  },
  async created() {
    this.loading = true;
    // TODO catch errors
    this.balance = (await getTokenBalance(this.token)).balance;

    this.items = await getTokenLog(this.token);
    console.log(this.items);
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
.tx-a {
  text-decoration: none;
}
</style>
